module.exports = __webpack_public_path__ + "img/cross_circle.b1fd73e7.svg";